/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import configData from "./config.json"

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": configData.cognito.USER_POOL_ID,
    "aws_user_pools_web_client_id": configData.cognito.APP_CLIENT_ID, 
    "oauth": {}
};
console.log(awsmobile)

export default awsmobile;
